import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import {NavLink, withRouter} from "react-router-dom";

class Children extends PureComponent {
  static propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        path: PropTypes.string,
        assetURL: PropTypes.string
      })
    ),
    activeItem: PropTypes.object,
    changeProduct: PropTypes.func,
    isMobile: PropTypes.bool,
    minimized: PropTypes.bool
  };
  isActive = (item) => item.product === this.props.activeItem.productName;
  render() {
    const {items, changeProduct, activeItem, minimized} = this.props;
    return (
      !!items &&
      items.map((item) => (
        <div
          key={item.product}
          className={`other-product department__item${
            this.isActive(item) ? ` other-product_active` : ``
          }`}
        >
          {!minimized && (
            <NavLink
              to={`/${item.path}${
                activeItem.id || activeItem.rawParentId
                  ? `?product_id=${activeItem.id || activeItem.rawParentId}`
                  : ``
              }`}
              className="other-product__link"
              onClick={changeProduct(item.pluralized_product)}
            >
              <img loading="lazy"
                src={item.assetURL}
                alt={item.title}
                className="other-product__img"
              />
            </NavLink>
          )}
          <NavLink
            to={`/${item.path}${
              activeItem.id || activeItem.rawParentId
                ? `?product_id=${activeItem.id || activeItem.rawParentId}`
                : ``
            }`}
            className="other-product__title"
            onClick={changeProduct(item.pluralized_product)}
          >
            {item.title}
          </NavLink>
        </div>
      ))
    );
  }
}

export default withRouter(Children);
